<!--上拉加载，下拉刷新半屏-->
<!--wj-->
<template>
  <div class="scroll-norefresh" id="scroll"
  :class="{'down':(state===0),'up':(state==1),refresh:(state===2),touch:touching}"
  @touchstart="touchStart($event)"
  @touchmove="touchMove($event)"
  @touchend="touchEnd($event)"
  @scroll="(onInfinite || infiniteLoading) ? onScroll($event) : undefined">
    <section class="inner" >
      <header class="pull-refresh">
        <slot name="pull-refresh">
           <span class="down-tip"><img :src="loadingImg" style="width:2rem;"><p>下拉更新</p></span>
           <span class="up-tip">松开更新</span>
           <span class="refresh-tip"><img :src="loadingImg" style="width:2rem;"><p>更新中</p></span>
        </slot>
      </header>
      <slot></slot>
      <footer class="load-more">
        <slot name="load-more" >
          <span v-if="loadingMore" style="color:rgb(150, 150, 150);text-align:center;"><img :src="loadingImg" style="width:2rem;"><p>加载中</p>
          </span>
          <span v-if="loadingNo" style="color:#969696;display: flex;justify-content: center;" class="upwarp-nodata"><hr class="myhr">没有更多内容<hr class="myhr"></span>
          <!-- <span v-if="loadingNo" style="color:rgb(150, 150, 150);">* 没有更多数据 *</span> -->
        </slot>
      </footer>
    </section>
  </div>
</template>

<script>
import { eventBus } from '@/assets/js/eventBus';
import { setTimeout } from 'timers';
import $ from 'jquery';
export default {
  props: {
    offset: {
      type: Number,
      default: 40
    },
    enableInfinite: {
      type: Boolean,
      default: true
    },
    enableRefresh: {
      type: Boolean,
      default: true
    },
    onRefresh: {
      type: Function,
      default: undefined,
      required: false
    },
    onInfinite: {
      type: Function,
      default: undefined,
      require: false
    }
  },
    data() {
        return {
        top: 0,
        state: 0,
        startY: 0,
        touching: false,
        infiniteLoading: false,
        loadingMore:true,
        loadingNo:false,
        Sloading:false,
        loadingImg:require('@/assets/image/loading.svg'),
        }
    },
    mounted() {
    const that = this;
    eventBus.$on("loadingMore",(val) => {
        if(val == false){
            that.loadingMore = val;
            that.loadingNo = true;
        }
    });
  },
  methods: {
    touchStart(e) {
      this.startY = e.targetTouches[0].pageY
      this.startScroll = this.$el.scrollTop || 0
      this.touching = true
    },
    touchMove(e) {
      if (!this.enableRefresh || this.$el.scrollTop > 0 || !this.touching) {
        return
      }
      let diff = e.targetTouches[0].pageY - this.startY - this.startScroll
      if (diff > 0) e.preventDefault()
      this.top = Math.pow(diff, 0.8) + (this.state === 2 ? this.offset : 0)

      if (this.state === 2) { // in refreshing
        return
      }
      if (this.top >= this.offset) {
        // this.state = 1
        // $("#scroll").addClass("up");
      } else {
        this.state = 0;
      }
    },
    touchEnd(e) {
      if (!this.enableRefresh) return
      this.touching = false
      if (this.state === 2) { // in refreshing
        this.state = 2
        this.top = this.offset
        return
      }
      if (this.top >= this.offset) { // do refresh
        this.refresh();
      } else { // cancel refresh
        this.state = 0;
        this.top = 0;
      }
    },
    refresh() {
        this.state = 2;
        this.top = this.offset;
        this.onRefresh(this.refreshDone);
        eventBus.$on("succed",(val) => {
           if(val){
               setTimeout(() => {
                 this.top = 0;
                this.state = 0;
             },500)
           }
        });
    },
    refreshDone() {
            this.state = 0;
            this.top = 0;
    },
    infinite() {
      this.infiniteLoading = true;
      this.onInfinite(this.infiniteDone);
    },
    infiniteDone() {
      this.infiniteLoading = false;
    },
    onScroll(e) {
      if (!this.enableInfinite || this.infiniteLoading) {
        return
      }
      let outerHeight = this.$el.clientHeight;
      let innerHeight = this.$el.querySelector('.inner').clientHeight;
      let scrollTop = this.$el.scrollTop;
      let ptrHeight = this.onRefresh ? this.$el.querySelector('.pull-refresh').clientHeight : 0;
      let infiniteHeight = this.$el.querySelector('.load-more').clientHeight;
      let bottom = innerHeight - outerHeight - scrollTop - ptrHeight;
      if (bottom < infiniteHeight) this.infinite();
    }
  },
  beforeDestroy(){
      eventBus.$off("loadingMore");
      eventBus.$off("succed");
  },
}
</script>
<style>
.scroll-norefresh {
  position: absolute;
  top: 0rem;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.scroll-norefresh .inner {
  position: absolute;
  top: -3rem;
  width: 100%;
  transition-duration: 300ms;
}
.scroll-norefresh .pull-refresh {
    position: fixed;
    left: 0;
    z-index: 1;
    top: 0rem;
    color: rgb(150, 150, 150);
    width: 100%;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
.scroll-norefresh.touch .inner {
  transition-duration: 0ms;
}
.scroll-norefresh.down .down-tip {
  display: block;
}
.scroll-norefresh.up .up-tip {
  display:block;
}
.scroll-norefresh.refresh .refresh-tip {
  display: block;
}
.scroll-norefresh .down-tip,
.scroll-norefresh .refresh-tip,
.scroll-norefresh .up-tip {
  display: none;
  text-align: center;
}
.scroll-norefresh .load-more {
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}  
</style>